import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, LucideIcon } from 'lucide-react';
import { motion } from 'framer-motion';

interface ExploreSidebarCardProps {
    to: string;
    icon: LucideIcon;
    text: string;
}

const ExploreSidebarCard: React.FC<ExploreSidebarCardProps> = ({ to, icon: Icon, text }) => {
    return (
        <div className="relative my-1">
            <Link to={to} className="block outline-none decoration-transparent">
                <motion.div
                    whileHover={{ scale: 1.01 }}
                    whileTap={{ scale: 0.99 }}
                    className="w-full p-2 transition-all rounded-lg bg-indigo-50 hover:bg-indigo-100 border border-indigo-100 cursor-pointer flex items-center justify-between group"
                >
                    <div className="flex items-center gap-3">
                        <div className="p-1.5 bg-white rounded-md shadow-sm text-indigo-600">
                            <Icon className="w-5 h-5" />
                        </div>
                        <span className="font-semibold text-gray-800 text-sm">
                            {text}
                        </span>
                    </div>
                    <ChevronRight className="w-5 h-5 text-indigo-400 group-hover:text-indigo-600 group-hover:translate-x-1 transition-transform" />
                </motion.div>
            </Link>
        </div>
    );
};

export default ExploreSidebarCard;
